import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./MapContact.css";
import Heading from "../../../utls/Heading";

const MapContact = () => {
  return (
    <>
      <div className="map-section  mb-5">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mt-5">
              <div className="d-flex justify-content-center">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3610.4875344150314!2d55.2605493!3d25.186776100000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f69a9ab6cc833%3A0x35515524eabea283!2sBlueberry%20Travel%20UAE-%20Best%20Corporate%20Travel%20Agency%20in%20UAE!5e0!3m2!1sen!2sin!4v1750254864627!5m2!1sen!2sin"
                  width="100%"
                  height="450"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"
                >
                  {" "}
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- .............................details-section.................................... --> */}

      <div className="details-section mt-5 pt-md-5">
        <div className="container px-xxl-5 px-lg-4 mt-md-3">
          <div className="row mb-md-5 px-xxl-3">
            <div className="col-md-6 col-lg-3 col-6  mb-lg-5 d-flex justify-content-center padding mb-2">
              <div className="box1 office position-relative">
                {/* Full clickable layer including text */}
                <a
                  href="https://maps.app.goo.gl/e1qZsiybpMUx9NaRA"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="position-absolute top-0 start-0 w-100 h-100 text-decoration-none text-dark"
                  style={{ zIndex: 2 }}
                >
                  {" "}
                </a>

                {/* Content below clickable <a>, but pointerEvents disabled to allow clicks to pass */}
                <div
                  className="d-flex flex-column pb-md-4 mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 position-relative"
                  style={{ zIndex: 1, pointerEvents: "none" }}
                >
                  <Heading
                    level={2}
                    className="headings text-center first-section position-relative zindex mt-md-4 mt-2"
                  >
                    Our Office
                  </Heading>
                  <p className="text-center mb-0">
                    The Regal Tower 1605, 
                    <br /> Business Bay, Dubai - UAE
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-6  mb-lg-5 d-flex justify-content-center padding mb-2">
              <div className="box1 phone position-relative">
                {/* Full clickable layer including text */}
                <a
                  href="tel:+97147707355"
                  className="position-absolute top-0 start-0 w-100 h-100 text-decoration-none text-dark"
                  style={{ zIndex: 2 }}
                >
                  {" "}
                </a>

                {/* Visible content, behind the link but still readable */}
                <div
                  className="d-flex flex-column pb-md-4 mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 position-relative"
                  style={{ zIndex: 1, pointerEvents: "none" }}
                >
                  <Heading
                    level={2}
                    className="headings text-center second-section position-relative zindex mt-md-4 mt-2"
                  >
                    Phone
                  </Heading>
                  <p className="text-center mt-md-3">UAE - +971 4770 7355</p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 col-6  mb-lg-5 d-flex justify-content-center padding mb-2">
              <div className="box1 email position-relative">
                <a
                  href="mailto:Info@blueberry-travel.com"
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{ zIndex: 2 }}
                >
                  {" "}
                  {/* Transparent clickable layer */}
                </a>

                {/* Actual content, placed behind the clickable <a> */}
                <div
                  className="d-flex flex-column mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 pb-4 position-relative"
                  style={{ zIndex: 1, pointerEvents: "none" }} // Ensures content doesn't block click
                >
                  <Heading
                    level={2}
                    className="headings text-center third-section position-relative zindex mt-md-4 mt-2"
                  >
                    Email
                  </Heading>
                  <p className="text-center mt-md-3">
                    Info@blueberry-travel.com
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-3 col-6  mb-lg-5 d-flex justify-content-center padding mb-2">
              <div className="box1 website position-relative">
                {/* Transparent clickable background layer */}
                <a
                  href="https://www.blueberry-travel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="position-absolute top-0 start-0 w-100 h-100"
                  style={{ zIndex: 1 }}
                >
                  {" "}
                </a>

                {/* Content layer with higher z-index */}
                <a
                  href="https://www.blueberry-travel.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="position-absolute top-0 start-0 w-100 h-100 text-decoration-none text-dark"
                  style={{ zIndex: 2 }}
                >
                  <div className="d-flex flex-column mt-xxl-5 mt-md-4 mt-0 pt-md-5 pt-5 pb-4 position-relative">
                    <Heading
                      level={2}
                      className="headings text-center fourth-section position-relative zindex mt-md-4 mt-2"
                    >
                      Website
                    </Heading>
                    <p className="text-center mt-md-3">
                      www.blueberry-travel.com
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MapContact;
